import { IRestrictions } from 'src/app/models';
import { IPagination, IRestrictionsState } from '../states';

export const initialRestrictionsState: IRestrictionsState = {
  value: [] as IRestrictions[],
  isFetchingRestrictions: false,
  pagination: {} as IPagination,
};
